import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { VisitorCalendarActionCommand, VisitorSettingsCommand, VisitorStyleCommand, VisitorTripCommand, VisitorTripIdCommand, } from '../commands/pagination.query.command';
import { AllFrontendSettingsCommand } from '../commands/visitor/all.frontend.settings.command';
import { TravelMode } from "../common/services/google.maps.service";
var VisitorCalendarStore = /** @class */ (function () {
    function VisitorCalendarStore() {
        this.actionCommand = new BehaviorSubject(new VisitorCalendarActionCommand());
    }
    return VisitorCalendarStore;
}());
export { VisitorCalendarStore };
var VisitorStyleStore = /** @class */ (function () {
    function VisitorStyleStore() {
        this.styleCommand = new BehaviorSubject(new VisitorStyleCommand());
    }
    return VisitorStyleStore;
}());
export { VisitorStyleStore };
var VisitorSettingsStore = /** @class */ (function () {
    function VisitorSettingsStore() {
        this.settingsCommand = new BehaviorSubject(new VisitorSettingsCommand());
    }
    return VisitorSettingsStore;
}());
export { VisitorSettingsStore };
var AllFrontendSettingsStore = /** @class */ (function () {
    function AllFrontendSettingsStore() {
        this.allFrontendSettingsCommand = new BehaviorSubject(new AllFrontendSettingsCommand());
    }
    return AllFrontendSettingsStore;
}());
export { AllFrontendSettingsStore };
var VisitorTripStore = /** @class */ (function () {
    function VisitorTripStore() {
        this.tripCommand = new BehaviorSubject(new VisitorTripCommand());
    }
    return VisitorTripStore;
}());
export { VisitorTripStore };
var VisitorTripIdStore = /** @class */ (function () {
    function VisitorTripIdStore() {
        this.tripIdCommand = new BehaviorSubject(new VisitorTripIdCommand());
    }
    return VisitorTripIdStore;
}());
export { VisitorTripIdStore };
var VisitorTripNotifyAddOrRemoveItemStore = /** @class */ (function () {
    function VisitorTripNotifyAddOrRemoveItemStore() {
        this.notifyCommand = new BehaviorSubject(null);
    }
    return VisitorTripNotifyAddOrRemoveItemStore;
}());
export { VisitorTripNotifyAddOrRemoveItemStore };
var TravelModeStore = /** @class */ (function () {
    function TravelModeStore() {
        this.modeCommand = new BehaviorSubject(TravelMode.DRIVING);
    }
    return TravelModeStore;
}());
export { TravelModeStore };
var VisitorDataCache = /** @class */ (function () {
    function VisitorDataCache() {
    }
    Object.defineProperty(VisitorDataCache, "places", {
        get: function () {
            return this._places;
        },
        set: function (places) {
            this._places = places;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisitorDataCache, "events", {
        get: function () {
            return this._events;
        },
        set: function (events) {
            this._events = events;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisitorDataCache, "logo", {
        get: function () {
            return this._logo;
        },
        set: function (logo) {
            this._logo = logo;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisitorDataCache, "tours", {
        get: function () {
            return this._tours;
        },
        set: function (tours) {
            this._tours = tours;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisitorDataCache, "placeCategories", {
        get: function () {
            return this._placeCategories;
        },
        set: function (placeCategories) {
            this._placeCategories = placeCategories;
        },
        enumerable: true,
        configurable: true
    });
    VisitorDataCache.addCustomDefaultPlaceCategoryMatMenus = function (customDefaultPlaceCategoryMatMenu, level) {
        if (this._customDefaultPlaceCategoryMatMenus.indexOf(customDefaultPlaceCategoryMatMenu) < 0) {
            this._customDefaultPlaceCategoryMatMenus.push({
                trigger: customDefaultPlaceCategoryMatMenu,
                level: level,
            });
        }
    };
    Object.defineProperty(VisitorDataCache, "customDefaultPlaceCategoryMatMenus", {
        get: function () {
            return this._customDefaultPlaceCategoryMatMenus;
        },
        enumerable: true,
        configurable: true
    });
    VisitorDataCache.clearCustomDefaultPlaceCategoryMatMenus = function () {
        this._customDefaultPlaceCategoryMatMenus = [];
    };
    VisitorDataCache._places = null;
    VisitorDataCache._events = null;
    VisitorDataCache._tours = null;
    VisitorDataCache._placeCategories = null;
    VisitorDataCache._logo = '';
    VisitorDataCache._customDefaultPlaceCategoryMatMenus = [];
    return VisitorDataCache;
}());
export { VisitorDataCache };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/stores/visitor.calendar.store.ts.pre-build-optimizer.js